export default {
	props:{
		id: String,
		name: String,
		value: [String, Number],
		type: {type: String, default: 'text'},
		autocomplete: String,
		label: String,
		floatingLabel:{type:Boolean, default:false},
		placeholder: String,
		clearable: {type:Boolean, default:false},
		disabled: {type:Boolean, default:false},
		errorMsg: String,
	},
	data(){
		return {
			innerValue: null,
			hintVisible: true,
			hasFocus: false,
			uniqueId: null,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(){ this.innerValue = this.value;},
		},
		innerValue:{
			immediate: true,
			handler(){
				//this.hintVisible = !this.innerValue;
				this.$emit('input', this.innerValue);
				this.$emit('change', this.innerValue);
			},
		},
	},
	computed:{
		hasValue(){
			return !!this.innerValue;
		},
		innerPlaceholder(){
			return this.placeholder && this.floatingLabel && (this.hasFocus || this.hasValue) ? '' : this.placeholder;
		},
		mainCssClass(){
			return ['styled-input', 'input-'+this.type, this.type==='radio'||this.type==='checkbox'?'h-auto':'', this.clearable?'clearable':'', this.floatingLabel?'floating-label':'', this.hasFocus?'focused':'', this.hasValue?'has-value':''];
		},
		elementId(){
			if(this.id) return this.id;
			if(this.name) return this.name.replaceAll('[','.').replaceAll(']','');
			if(this.uniqueId) return this.uniqueId;
			return '';
		}
	},
	methods: {
		onClear(){
			this.innerValue = '';
			this.$emit('clear');
		},
		focus(){
			this.$refs.inputElement.focus();
		},
		blur(){
			this.$refs.inputElement.blur();
		},
		onFocus(){
			this.hasFocus = true;
			this.$emit('focus');
		},
		onBlur(){
			this.hasFocus = false;
			this.$emit('blur');
		},
	},
	mounted() {
		this.uniqueId = this._uid?'id-'+this._uid:'';
		setTimeout(()=>{
			if(this.$refs.inputElement && (this.$refs.inputElement.matches(':autofill') || this.$refs.inputElement.matches(':-webkit-autofill'))){
				this.hasFocus = true;
			}
		}, 600);
	},
	template: `
<div :class="mainCssClass">
	<label v-if="label" class="ext-label" :for="elementId">{{label}}</label>
	<template v-if="type==='textarea'">
		<textarea ref="inputElement" :id="elementId" :name="name" :placeholder="innerPlaceholder" v-model="innerValue" :autocomplete="autocomplete" @focus="onFocus" @blur="onBlur" :disabled="disabled"></textarea>
	</template>
	<template v-else>
		<input ref="inputElement" :id="elementId" :name="name" :type="type" :placeholder="innerPlaceholder" v-model="innerValue" :autocomplete="autocomplete" @focus="onFocus" @blur="onBlur" :disabled="disabled"/>
	</template>
	<span v-if="hintVisible && errorMsg" class="hint error-msg" v-t="errorMsg"></span>
	<span v-if="clearable && hasValue" class="clear-btn" @click="onClear"></span>
</div>
`,
}
